/**
 * GoDatePipe created by karora on 14/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {AppComponent} from "../app.component";
/*
 * Format a stringified ISO8601 date more prettily
 */
@Pipe({
    name: 'godate',
    standalone: false
})
export class GoDatePipe implements PipeTransform {
  transform(value: string): string {
    try {
      let d = new Date(value);
      let s: string = AppComponent.zpad(d.getFullYear(), 4) + '-' + AppComponent.zpad(d.getMonth() + 1, 2) + '-' + AppComponent.zpad(d.getDate(), 2);
      s += ' ' + AppComponent.zpad(d.getHours(), 2) + ':' + AppComponent.zpad(d.getMinutes(), 2) + ':' + AppComponent.zpad(d.getSeconds(), 2);
//      console.log("value: " + value + ', s=' + s + ", day=" + d.getDay());
//      let options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
//      console.log(d.toLocaleString('ko-KO', options));
//      return d.toISOString().slice(0, 19);
      return s;
    } catch(err) {
      console.debug(err);
      return value;
    }
  }
}
